import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=7d5f6408&scoped=true"
import script from "./menus.vue?vue&type=script&lang=ts"
export * from "./menus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5f6408",
  null
  
)

export default component.exports